import React, { FunctionComponent, useMemo } from 'react';
import { useSelectWithParams } from '../../../../../../../../utils/selector.utils';
import { IWidgetKpiRowGroupParams } from './types';
import { kpiRowSelectors } from '../../../../../../../../app/resource/kpi-row/kpi-row.selectors';
import { IKpiRow } from '../../../../../../../../app/resource/kpi-row/kpi-row.types';
import WidgetKpiSortableRow from '../WidgetKpiSortableRow';

export const WidgetKpiRowGroup: FunctionComponent<IWidgetKpiRowGroupParams> = ({ kpiRowIds }) => {
  const kpiRows = useSelectWithParams(kpiRowSelectors.selectResourcesById, kpiRowIds) as IKpiRow[];

  const groupedRows = useMemo(() => {
    return kpiRows.reduce((acc, row) => {
      const userId = row.userId;
      if (!acc[userId]) {
        acc[userId] = [];
      }
      acc[userId].push(row.id);
      return acc;
    }, {} as Record<string, string[]>);
  }, [kpiRows]);
  return (
    <div>
      {Object.entries(groupedRows).map(([userId, rowIds]) => (
        <div key={userId} style={{ paddingBottom: '20px', height: 'auto' }}>
          {rowIds.map((kpiRowId, index) => (
            <WidgetKpiSortableRow key={kpiRowId} kpiRowId={kpiRowId} index={index} />
          ))}
        </div>
      ))}
    </div>
  );
};
